module.exports = "/_next/static/images/f0e9d8f048d4d8731dc0ff0e3bd009d7-blog2-xs.png.webp";